
<template>

    <div class="d-flex flex-column fill-height min-h-screen">
      <v-navigation-drawer
    :model-value="modelValue"
    location="right"
    temporary
    width="1000"
    @update:modelValue="handleCancel"
  
  >
    <v-toolbar flat>
      <v-toolbar-title>
        {{ entityState.editorMode === 'create'
            ? 'Create'
            : 'Edit' }}
      </v-toolbar-title>

      <v-spacer />

      <v-btn aria-label="Close Drawer" icon="mdi-close" 
      ref="closeDrawer"
      @click="handleCancel" />
    </v-toolbar>

    <v-divider />

    <v-container fluid>

      <GroupSection
        :entityType="entityType"
        v-model="entityState.formState"
        :editorMode = "entityState.editorMode"
        :path="[]"
        :itemName="itemName"
      />

    <PermissionSection 
    v-model="configState" 
    v-if="
      userStore.accesslevel === 'SysAdmin' && 
      entityState.editorMode !== 'create' && 
      entityType !== 'users'
    "
    :entityType="entityType"
    :entityState="entityState.formState"
    /> 
      <v-divider class="my-4" />

    </v-container>

    <v-divider />

    <v-card-actions class="justify-end pa-4">
      <v-btn aria-label="Cancel Edit"
      variant="text" @click="handleCancel">
        Cancel
      </v-btn>

      <v-btn
        aria-label="Save Changes"
        color="primary"
        @click="handleSave"
        :disabled="shouldDisable"
      >
             {{ entityState.editorMode === 'create'
            ? 'CREATE'
            : 'SAVE' }}
      </v-btn>
    </v-card-actions>

  </v-navigation-drawer>
   </div>
</template>

<script setup>
import { computed, ref , provide, watch, nextTick} from 'vue'
import { useEntityStore } from '@/store/useEntityStore'
import GroupSection from "./GroupSection.vue"
import PermissionSection from "./PermissionSection.vue"
import { useUserStore} from '@/store/user'
import {useLogger} from "@/composables/useLogger"
const {sendLog} = useLogger() 
const userStore = useUserStore()

const drawer = ref(false)
const shouldDisable = ref(false)

const closeDrawer = ref(null)

provide("toggleSubmit", (val) => {
  shouldDisable.value = val
})

const props = defineProps({
  modelValue: Boolean,
  entityType: String,
  itemId: String,
  itemName: String
})


const emit = defineEmits(["cancel"])

const store = useEntityStore()

const entityState = computed(() =>
  store.getEntityState(props.entityType)
)

const configState = computed(() => {
  return store.getEntityConfig(props.itemId)
})


async function handleSave() {
  const result = await store.save(props.entityType)
  sendLog("debug", "handle_drawer_save", result)
  if (!result.ok) {
    emit('completed', false, result.error.message)
  }else{
    emit('completed', true)
  }
}

function handleCancel() {
  emit("cancel")
  store.resetEditor(props.entityType)
}

watch(() => props.modelValue, async (isOpen) => {
  console.log("watch block runs", isOpen)
  if (isOpen) {
    console.log("isOpen is true, fetching detail")
    await nextTick()
    if(closeDrawer.value?.$el){
      closeDrawer.value.$el.focus()
    }
  }
},{ immediate: true })

</script>
